<template>
  <div class="btn_group type2">
    <div class="mo_hidden">
      <mpn-basic-button
        :disabled="!recommendationsFetched"
        @click="$emit('on-click-recombination');"
      >
        조합수정
      </mpn-basic-button>

      <mpn-basic-button
        color="navy"
        :disabled="!recommendationsFetched"
        @click="$emit('on-click-apply')"
      >
        바로신청
      </mpn-basic-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeMainBtnGroup',
  components: {
  },
  computed: {
    ...mapGetters({
      recommendationsFetched: 'recommendation/recommendationsFetched',
    }),
  },
};
</script>
